import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IStyleProps {
  dragging?: boolean;
}
  
export const Root = styled.div`  
`

export const Label  = styled.span`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ccc;
  margin-right: 11px;
`;

export const AddArtboard  = styled.div`
  margin-right: 16px;
  margin-top: -2.5px;
  &:hover svg path {
    fill: ${(props: IStyleProps) => (!props.dragging ? C.WHITE : '#818181')};
  }
`;


export const Drag  = styled.div`
  margin-right: 16px;
  margin-top: -2.5px;
  &:hover svg path {
    fill: ${(props: IStyleProps) => (!props.dragging ? C.WHITE : '#818181')};
  }
`;

export const SliderContainer = styled.div`
  display:flex;  
  width:99px;
  margin-top: 2px;
`;

export const Button = styled.div`
`;